export const USER_PERSIST_KEY = 'tadarida-user-v1';
export const USER_PERSIST_OPTIONAL_KEY = 'tadarida-optional-user-v1';
export const TADARIDA_SESSION_PERSIST_KEY = 'tadarida-session-v1';
